import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import basicScienceFacultyData from "./facultyData/basicScienceFacultyData";

const departmentOverview = {
  paragraphs: [""],
};

const physicsFacultyNames = {
  "f-sameer-m-galagali": "Dr. S.M.Galagali",
  "f-m-s-sannaikar": "Dr. M.S.Sannaikar",
  "f-mallikarjun-k-patil": "Dr. M. K. Patil",
};

const facultyOrder = [
  "f-mallikarjun-k-patil",
  "f-sameer-m-galagali",
  "f-m-s-sannaikar",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const physicsFaculty = getOrderedFacultyMembers(
  [
    basicScienceFacultyData.hod,
    ...basicScienceFacultyData.members,
  ].filter((faculty) => Object.keys(physicsFacultyNames).includes(faculty.id))
).map((faculty) => ({
    ...faculty,
    name: physicsFacultyNames[faculty.id],
  }));

const physicsFacultyData = {
  hod: null,
  members: physicsFaculty,
};

export const programme = {
  id: "physics",
  name: "Physics",
  short: "Physics",
  programmeType: "ug",
  programmeLabel: "",
  duration: "First-year engineering foundation",
  intake: "510+",
  established: 2004,
  description:
    "The Physics department offers Engineering Physics as a first-semester/second-semester core subject for all B.E. programmes. The course is designed to build strong conceptual and experimental foundations in modern physics, optics, quantum mechanics, and material science relevant to engineering applications.",
  departmentOverview,
  dashboard: [
    ["Faculty Members", "03"],
    ["Faculty with Ph.D.", "03"],
    ["Laboratories", "01"],
    ["Students Enrolled", "510+"],
  ],
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The department has experienced faculty, modern laboratories, and strong mentoring support.Students consistently perform well in VTU examinations and engage in research activities.Industry interaction, value education, and professional ethics support overall development",
    },
    {
      title: "Practical Learning and Innovation",
      text: "The department combines classroom learning with Engineering Physics laboratory practice, demonstrations, and applied experiments.",
    },
    {
      title: "Beyond Syllabus",
      text: "Students connect physics foundations with materials, electronics, optics, computational methods, and emerging engineering applications.",
    },
  ],
  programmesOffered: {
    title: "Course Details",
    description:
      "Engineering Physics course structure for first-year B.E. students.",
    columns: ["Attribute", "Details"],
    rows: [
      [
        "Course Offered",
        "Engineering Physics (1BPHYEC102/202, 1BPHYEE102/202, 1BPHYC102/202, 1BPHEE102/202, 1BPHY M102/202, as per VTU scheme)",
      ],
      ["Semester", "I & II (First Year B.E.)"],
      ["Credits", "4 (3 Theory + 1 Lab)"],
      ["Laboratory", "Engineering Physics Lab"],
      [
        "Key Topics",
        "Quantum Mechanics, Lasers, Optical Fibres, Semiconductor Physics, Electrical Properties of Materials",
      ],
      ["Faculty Strength", "3"],
      ["Ph.D. Holders", "3"],
      [
        "Research Areas",
        "Nanomaterials, Spectroscopy, Computational Physics, Thin Films",
      ],
    ],
  },
  image:
    "/Academics/physics.jpg",
  facultyDeptId: "bsh",
  facultyData: physicsFacultyData,
  labs: ["Engineering Physics Lab"],
  research: "Nanomaterials · Spectroscopy · Computational Physics · Thin Films",
  accreditation: [
    "VTU-affiliated first-year curriculum",
    "AICTE-approved engineering programme support",
  ],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        { label: "Physics Achievements", href: "#" },
      ],
    },
  ],
  courseOutcomes: {
    title: "Course Outcomes (COs) - Engineering Physics (1BPHYEC102/202)",
    columns: ["CO No.", "Course Outcome"],
    rows: [
      [
        "CO1",
        "Discuss quantum mechanics to analyze microscopic systems, quantized states, and tunneling.",
      ],
      [
        "CO2",
        "Analyze electrical conduction in metals and semiconductors, including carrier concentration and Fermi energy.",
      ],
      [
        "CO3",
        "Summarize superconductivity phenomena and their applications in advanced materials.",
      ],
      [
        "CO4",
        "Describe light-matter interaction, lasers, modulators, and photonic devices in sensor technologies.",
      ],
      [
        "CO5",
        "Apply principles and applications of semiconductor, optical devices, sensors, and transducers in electronic and photonic systems.",
      ],
    ],
  },
  projects: [],
};

const Physics = () => <ProgrammeDetail programme={programme} />;

export default Physics;
